<template>

  <ion-page style="padding-top: 50px;">
    <ion-content style="height: 100%; overflow-y: auto; padding-top: 70px;">

      <!-- Swiper Section with Captions (unchanged) -->
      <ion-item
        style=" width: 100%; display: inline-flex; background-image: url('https://aes-site-assets.pages.dev/logo-resized.png');">
        <div :slides-per-view="1" :navigation="true" :pagination="true" :autoplay="true" :speed="500"
          class="responsive-swiper" style="padding-top:20px;">
          <swiper-slide v-for="(slide , index) in slides" :key="index" style="position: relative;">
            <img class="swiper-image" :src="slide.image" :alt="'Slide ' + (index + 1)" />
            <div v-if="slide.caption" class="slide-caption">{{ slide.caption }}</div>
          </swiper-slide>
        </div>
      </ion-item>

      <!-- Tagline -->
      <ion-item lines="none">
        <div style="text-align: center; width: 100%; text-align: center;">
          <h1>Your Trusted Partner in Residential and Commercial Electrical & Low Voltage Systems</h1>
          <p style="color:#1C8AF7">
            Jonathan M Net delivers reliable, professional‑grade solutions in commercial electrical and
            low‑voltage installations. our
            electricians and technicians are equipped to handle projects of any scale.
          </p>
        </div>
      </ion-item>

      

      <!-- Services -->
      <ion-item>
        <div>
          <h1>Our Services</h1>
          <p style="color:#1C8AF7; margin-right:20vw">
            We specialize in electrical installs, access control systems, security cameras, and structured cabling for copper.
          </p>
        </div>
      </ion-item>

      <!-- Experience & Credibility -->
      <ion-item>
        <div>
          <h1>Decades of Experience You Can Rely On</h1>
          <p style="color:#1C8AF7; margin-right:20vw; text-align: center; ">
            With years of field experience and continuous training in the latest technologies, our experts bring
            unmatched value to every installation. Whether it's conduit work, panel installs, or low voltage
            integration,
            we’ve done it—and done it right.
          </p>
        </div>
      </ion-item>

      <!-- Featured Projects -->
      <ion-item>
        <div>
          <h1>Recent Projects</h1>
          <p style="color:#1C8AF7; margin-right:20vw; text-align: center;">
            We’ve successfully completed installations in airports, schools, warehouses, and government facilities.
            Explore our <b @click="$router.push('/projects')"
              style="color:#0D47A1; cursor: pointer; text-decoration: underline;">Projects</b> page to learn more.
          </p>
        </div>
      </ion-item>

      <!-- Testimonials -->
      <ion-item>
        <div>
          <h1>What Our Clients Say</h1>
          <p style="color:#1C8AF7; margin-right:20vw; text-align: center;">
            "Jonathan M Net exceeded our expectations with their professionalism and technical expertise."
            <br />– Home Owner
          </p>
        </div>
      </ion-item>

      <!-- CTA at bottom -->
      <ion-item lines="none">
        <div style="width:100%; display:flex; justify-content:center;">
          <ion-button style="width: 70vw;" class="estimate-cta" expand="block" shape="round" size="large"
            @click="$router.push('/requestquote')">
            Get an Estimate
          </ion-button>
        </div>
      </ion-item>

    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonImg,IonButton } from '@ionic/vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { register } from 'swiper/element/bundle';
import { isMobile } from '../helper';
register();
import 'swiper/swiper-bundle.css';
import { ref,onBeforeMount } from 'vue';
import { Navigation, Pagination, Scrollbar, A11y,Controller } from 'swiper/modules';



const bicsiLogo = new URL('../assets/homepage/bicsi.png', import.meta.url).href;

const images = ref<string[]>([]);

const slides = ref([
  { image: "https://portfolio-assets-7zc.pages.dev/banner.png",caption: "" }
 
]);

</script>

<style scoped>
#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}

img {
  width: 100%;
  height: auto;
}
</style>
<style scoped>
.swiper-parent {
  width: 100vw;
  display: flex !important;
  justify-content: center;
  align-items: center;
  background: transparent !important;
  border: none;
}

.responsive-swiper {
  width: 60vw;
  max-width: 900px;
  aspect-ratio: 16/9;
  min-width: 320px;
  min-height: 220px;
  max-height: 500px;
  border-radius: 32px;
  overflow: hidden;
  background: #18191a;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
  margin: 2vh auto 2vh auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.swiper-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  background: #18191a;
}

@media (max-width: 900px) {
  .responsive-swiper {
    width: 90vw;
    height: 32vh;
    min-width: 180px;
    min-height: 120px;
    border-radius: 16px;
  }
}

@media (max-width: 600px) {
  .responsive-swiper {
    width: 98vw;
    height: 24vh;
    min-width: 120px;
    min-height: 80px;
    border-radius: 10px;
  }
}

.slide-caption {
  position: absolute;
  bottom: 12px;
  right: 16px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 6px 10px;
  font-size: 0.9rem;
  border-radius: 4px;
}

.estimate-cta {
  --background: linear-gradient(135deg, #1C8AF7, #0D47A1);
  --background-activated: linear-gradient(135deg, #1565C0, #0A3675);
  --border-radius: 30px;
  margin-top: 30px;
  margin-bottom: 40px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-radius: 30px;

}

.estimate-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(24, 124, 242, 0.4);
}

.estimate-cta:active {
  transform: translateY(0);
  box-shadow: 0 4px 8px rgba(24, 124, 242, 0.4);
}
</style>